import { Injectable, signal } from '@angular/core';

/**
 * Abre os modais de login / cadastro / esqueci a senha por cima da rota atual
 * (ex.: visitante em detalhe de lista), sem navegar para a landing.
 */
@Injectable({ providedIn: 'root' })
export class AuthOverlayService {
  readonly loginOpen = signal(false);
  readonly signupOpen = signal(false);
  readonly forgotPasswordOpen = signal(false);

  requestLogin(): void {
    this.signupOpen.set(false);
    this.forgotPasswordOpen.set(false);
    this.loginOpen.set(true);
  }

  requestSignup(): void {
    this.loginOpen.set(false);
    this.forgotPasswordOpen.set(false);
    this.signupOpen.set(true);
  }

  closeLogin(): void {
    this.loginOpen.set(false);
  }

  closeSignup(): void {
    this.signupOpen.set(false);
  }

  requestForgotPassword(): void {
    this.loginOpen.set(false);
    this.forgotPasswordOpen.set(true);
  }

  closeForgotPassword(): void {
    this.forgotPasswordOpen.set(false);
  }

  /** “Criar conta” a partir do login. */
  switchLoginToSignup(): void {
    this.closeLogin();
    this.requestSignup();
  }

  /** “Entrar” a partir do cadastro. */
  switchSignupToLogin(): void {
    this.closeSignup();
    this.requestLogin();
  }
}
